import { useEffect } from 'react';
import { useAdminChannelsStore } from '../stores/adminChannels.store';

export const useAdminChannels = () => {
  const store = useAdminChannelsStore();
  const load = useAdminChannelsStore((s) => s.load);

  useEffect(() => { load(); }, [load]);

  return store;
};
